import Snackbar from "@mui/material/Snackbar";
import React, { createContext, useContext, useState } from "react";
import MuiAlert from "@mui/material/Alert";
import { IconButton } from "@mhome/ui";
import CloseIcon from "@mui/icons-material/Close";
import { useCustomTheme } from "../theme-shadcn";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ToastContext = createContext(null);

export function useToast() {
  return useContext(ToastContext);
}

export const ToastProvider = ({ children }) => {
  const [notification, setNotification] = useState("");
  const [notificationLevel, setNotificationLevel] = useState("success");
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { palette } = useCustomTheme();

  const errorToast = (msg) => {
    setNotification(msg);
    setNotificationLevel("error");
    setNotificationOpen(true);
  };

  const warningToast = (msg) => {
    setNotification(msg);
    setNotificationLevel("warning");
    setNotificationOpen(true);
  };

  const successToast = (msg) => {
    setNotification(msg);
    setNotificationLevel("success");
    setNotificationOpen(true);
  };

  const handleNotificationClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotificationOpen(false);
  };

  const getBackgroundColor = (level) => {
    switch (level) {
      case "success":
        return palette?.background?.l2 || "#9fe3a8";
      case "error":
        return palette?.background?.l4 || "#d19191";
      case "warning":
        return palette?.background?.l3 || "#e1c9a8";
      default:
        return palette?.background?.l0 || "#FFFFFF";
    }
  };

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleNotificationClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <ToastContext.Provider value={{ successToast, warningToast, errorToast }}>
      {children}
      <Snackbar
        open={notificationOpen}
        autoHideDuration={3000}
        onClose={handleNotificationClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={notificationLevel}
          variant="filled"
          style={{
            width: "100%",
            backgroundColor: getBackgroundColor(notificationLevel),
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
          action={action}
          onClose={handleNotificationClose}
        >
          {notification}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};
